import React, {memo} from 'react';
import {useSelector} from 'react-redux';
import {useLocalizer} from '@/common/services/localizer';
import {selectDomainConfig} from '@/app/store/config/selectors';
import {TextLink} from '@/common/components/TextLink';
import forecaLogo from '@/common/styles/img/foreca.svg?file';
import styles from './AppFooter.css';

export const AppFooter = memo(() => {
	const t = useLocalizer();
	const {domainName} = useSelector(selectDomainConfig);

	const currentYear = new Date().getFullYear().toString();

	return (
		<footer className={styles.root}>
			<p className={styles.info}>
				{t('copyright', {domain: domainName, currentYear})} {t('partners')}{' '}
				<img className={styles.forecaLogo} src={forecaLogo} alt='FORECA logo' />
			</p>
			<p>
				<TextLink className={styles.link} href={'/agreement'}>
					{t('termsAgreement')}
				</TextLink>
				<TextLink className={styles.link} href={'/privacypolicy'}>
					{t('privacyAgreement')}
				</TextLink>
				<TextLink className={styles.link} href={`/feedback?skin=desktop&lang=${t.language}`}>
					{t('sendGeneralFeedback')}
				</TextLink>
				<TextLink className={styles.link} href={`/feedback?skin=desktop&lang=${t.language}&mode=ads`}>
					{t('sendAdQuestion')}
				</TextLink>
			</p>
		</footer>
	);
});

AppFooter.displayName = 'AppFooter';
